"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useTimePassed;

var _react = require("react");

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
} // Returns true if Date.now() > at, otherwise, false.
// If Date.now() does not meet "at" yet, will trigger a refresh when Date.now() meet "at".


function useTimePassed(timeAt) {
  var now = Date.now();

  var _useState = (0, _react.useState)(),
      _useState2 = _slicedToArray(_useState, 2),
      _ = _useState2[0],
      setDummy = _useState2[1];

  var passed = now >= timeAt;
  (0, _react.useEffect)(function () {
    if (!passed) {
      var timeout = setTimeout(function () {
        return setDummy({});
      }, Math.max(0, timeAt - now));
      return function () {
        return clearTimeout(timeout);
      };
    }
  }, [now, passed, timeAt]);
  return passed;
}